// ------------------------------------------------------------
// 1. Menu Mobile
// ------------------------------------------------------------
(() => {
    document.addEventListener('DOMContentLoaded', () => {
    const html = document.documentElement;
    const menu = document.getElementById('mobileMenu');
    const btn  = document.getElementById('hamburger-button');
    const header = document.querySelector('[data-header]');
    if (!menu || !btn) return;

    const SHOWN  = ['opacity-100', 'translate-y-0', 'pointer-events-auto'];
    const HIDDEN = ['opacity-0', '-translate-y-full', 'pointer-events-none'];

    let isOpen = false;
    let isAnimating = false;
    let desired = null; // pour coalescer les spams

    // Utilitaire: attend la fin de la transition du menu (une seule fois)
    function waitTransition() {
        return new Promise((resolve) => {
        const onEnd = (e) => {
            // On s'assure que ça vient bien du menu (pas d'un enfant)
            if (e.target !== menu) return;
            menu.removeEventListener('transitionend', onEnd);
            resolve();
        };
        menu.addEventListener('transitionend', onEnd);
        });
    }

    async function setMenu(open) {
        // Coalescer si animation en cours
        if (isAnimating) {
        desired = open;
        return;
        }
        if (open === isOpen) return;

        isAnimating = true;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true; // bloque les spams pendant l'anim

        // Accessibilité + scroll lock
        btn.setAttribute('aria-expanded', String(open));
        html.style.overflow = open ? 'hidden' : '';

        if (open) {
        // 1) rendre visible mais EN ÉTAT FERMÉ
        menu.classList.remove('hidden');
        menu.classList.add(...HIDDEN);
        menu.classList.remove(...SHOWN);

        // 2) forcer un reflow pour que le navigateur "prenne" l'état fermé
        //    puis basculer vers l'état ouvert => transition lissée
        // eslint-disable-next-line no-unused-expressions
        menu.offsetWidth;

        // 3) lancer l'animation d'ouverture
        menu.classList.remove(...HIDDEN);
        menu.classList.add(...SHOWN);

        await waitTransition();
        isOpen = true;
        if (header) {
          header.setAttribute('data-mobile-menu-open', 'true');
          header.removeAttribute('data-hidden');
        }
        } else {
        // 1) lancer l'animation de fermeture
        menu.classList.remove(...SHOWN);
        menu.classList.add(...HIDDEN);

        await waitTransition();

        // 2) cacher totalement après la transition
        menu.classList.add('hidden');
        isOpen = false;
        if (header) {
          header.removeAttribute('data-mobile-menu-open');
        }
        }

        isAnimating = false;
        btn.removeAttribute('aria-busy');
        btn.disabled = false;

        // Si des clics ont été spammés pendant l'anim, on applique l'état désiré
        if (desired !== null && desired !== isOpen) {
        const next = desired;
        desired = null;
        setMenu(next);
        } else {
        desired = null;
        }
    }

    function toggleMenu() {
        setMenu(!isOpen);
    }

    btn.addEventListener('click', toggleMenu);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen) setMenu(false);
    });
    });
})();
// ===========================================================
// 🟦 2. HEADER SHRINK ON SCROLL
// ===========================================================
(() => {
    let observer;
  
    function setupHeaderShrink() {
      const header = document.querySelector('header');
      if (!header) return;
  
      // Crée un sentinel juste au-dessus du body
      let sentinel = document.getElementById('headerSentinel');
      if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.id = 'headerSentinel';
        sentinel.style.cssText = 'position:absolute;top:0;height:1px;pointer-events:none;';
        document.body.insertBefore(sentinel, document.body.firstChild);
      }
  
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
      if (observer) observer.disconnect();
  
      observer = new IntersectionObserver(
        (entries) => {
          const atTop = entries[0].isIntersecting;
          
          // Récupérer tous les éléments qui doivent recevoir data-scrolled
          const headerContent = document.getElementById('headerContent');
          const headerLogo = document.getElementById('headerLogo');
          const logoText = document.getElementById('logoText');
          
          // Liste des éléments à modifier
          const elementsToUpdate = [header, headerContent, headerLogo, logoText].filter(Boolean);
          
          if (reduceMotion) {
            elementsToUpdate.forEach(element => {
              element.toggleAttribute('data-scrolled', !atTop);
            });
            return;
          }
          
          // Appliquer data-scrolled à tous les éléments
          elementsToUpdate.forEach(element => {
            if (atTop) {
              element.removeAttribute('data-scrolled');
            } else {
              element.setAttribute('data-scrolled', 'true');
            }
          });
        },
        { threshold: 0, rootMargin: '-1px 0px 0px 0px' }
      );
  
      observer.observe(sentinel);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupHeaderShrink);
    } else {
      setupHeaderShrink();
    }
  
    document.addEventListener('shopify:section:load', setupHeaderShrink);
    document.addEventListener('shopify:section:unload', setupHeaderShrink);
  })();

// ===========================================================
// 🟧 3. MOBILE HEADER HIDE/SHOW ON SCROLL
// ===========================================================
(() => {
  const MOBILE_BREAKPOINT = 768;
  const HIDE_THRESHOLD = 12;
  const SHOW_THRESHOLD = 8;
  const MIN_SCROLL_TO_HIDE = 80;

  let header;
  let lastY = 0;
  let ticking = false;
  let isHidden = false;
  let mediaQuery;

  function showHeader() {
    if (!header || !isHidden) return;
    header.removeAttribute('data-hidden');
    isHidden = false;
  }

  function hideHeader() {
    if (!header || isHidden) return;
    header.setAttribute('data-hidden', 'true');
    isHidden = true;
  }

  function update() {
    if (!header) return;

    const currentY = Math.max(window.scrollY, 0);
    const delta = currentY - lastY;
    lastY = currentY;
    ticking = false;

    if (!mediaQuery || mediaQuery.matches || header.hasAttribute('data-mobile-menu-open')) {
      showHeader();
      return;
    }

    if (currentY <= MIN_SCROLL_TO_HIDE) {
      showHeader();
      return;
    }

    if (delta > HIDE_THRESHOLD) {
      hideHeader();
    } else if (delta < -SHOW_THRESHOLD) {
      showHeader();
    }
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function handleMediaChange() {
    if (!mediaQuery) return;
    if (mediaQuery.matches) {
      showHeader();
    }
  }

  function init() {
    header = document.querySelector('[data-header]');
    if (!header) return;

    mediaQuery = window.matchMedia(`(min-width: ${MOBILE_BREAKPOINT}px)`);
    lastY = Math.max(window.scrollY, 0);

    window.addEventListener('scroll', onScroll, { passive: true });

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleMediaChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleMediaChange);
    }

    // Initial sync
    window.requestAnimationFrame(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
